import React from "react";
import { PLATFORM_MODULES } from "@miplatform/constants";
import {
  CalendarEventType,
  IAttempt,
  PopperPlacement,
} from "@miplatform/types";
import { useTheme } from "@mui/material";
import { useCalendarContext } from "../../providers";
import { OrderInfoCard } from "../Orders/OrdersList/OrderInfoCard/OrderInfoCard";
import { Holds } from "../Schedule/Holds/Holds";
import { NHCWorkOrderCard } from "./NHCPriorityScheduler/NHCWorkOrderCard";
import { NhcOrderCard } from "./NhcOrderCard";
import { WorkOrderHoldList } from "./WorkOrderHoldList/WorkOrderHoldList";

const OrderInfoCardComponent = OrderInfoCard as React.ComponentType<any>;

export const HoldsListCalendar: React.FC<HoldsListCalendarProps> = ({
  onRefresh,
  orderReasons,
}) => {
  const {
    events: holdsData,
    calendarConfig,
    calendarSet,
    trayBuckets,
    setSelectedAttempt,
    isCalendarLoading,
  } = useCalendarContext();
  const theme = useTheme();

  const EventCard = React.useCallback(
    (props: { event: IAttempt }) => {
      const { event } = props;
      const holdType = event?.assignment?.order?.holdCalendarId
        ? calendarSet?.calendars?.[event.assignment.order.holdCalendarId]
            ?.config?.name
        : undefined;

      if (calendarSet?.config.eventType === CalendarEventType.WorkOrder) {
        return <NHCWorkOrderCard attempt={event} />;
      }

      return (
        <NhcOrderCard
          data={props.event}
          onRefresh={onRefresh}
          orderReasons={orderReasons}
          setSelectedOrder={() => {}} // TODO: Handle this if needed
          headerColor={
            event.assignment?.order?.orderTemplateColor ??
            theme.palette.grey.primary
          }
          calendarSet={calendarSet}
          holdType={holdType}
          popperPlacement={PopperPlacement.Top}
          popperComponent={
            <OrderInfoCardComponent
              order={{
                home: event.home,
                ...event?.assignment?.order,
                notes: event?.assignment?.order?.orderNotes,
              }}
              holdType={holdType}
            />
          }
        />
      );
    },
    [onRefresh, orderReasons, calendarSet]
  );

  if (calendarSet?.config.eventType === CalendarEventType.WorkOrder) {
    return <WorkOrderHoldList />;
  }

  return (
    <Holds
      skipEventWrapper
      refresh={null}
      hideActionMenu
      calendar={calendarConfig}
      holdsData={holdsData}
      getHoldsData={onRefresh}
      isLoading={isCalendarLoading}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      buckets={trayBuckets as any}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      EventCard={EventCard as any}
      updateCalendarCounts={() => {}}
      activeTab={null}
      count={null}
      viewConfig={{}}
      calendarSet={calendarSet}
      onCloseoutDrawerOpen={setSelectedAttempt}
      orderReasons={orderReasons}
      module={PLATFORM_MODULES.MI_SCHEDULING}
    />
  );
};

interface HoldsListCalendarProps {
  onRefresh: () => void;
  orderReasons: {
    holdReasons: { value: string; label: string }[];
    rescheduleReasons: { value: string; label: string }[];
  };
}
